import React from 'react';
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import LoadingIndicator from '../../components/LoadingIndicator';

import {
  STAGE,
  STRIPE_BASE_URL,
  STRIPE_BASIC_PRODUCT_ID,
  STRIPE_PUBLIC_KEY,
} from '../../constants';

const BASE_URL = STRIPE_BASE_URL;
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {},
  },
}));
const RenewButton = ({
  course,
  handleClassClick,
  index,
  isRenewal,
  size
}) => {
  console.log(course);
  const classes = useStyles();

  const [isLoading, setLoading] = React.useState(false);
  const [isSelected, setSelected] = React.useState(false);
  const handleClick = () => {
    handleClassClick(course, true);
  };
  const productId = course.stripeConfig.basicProductPlan;
  const styling =
    size && size === 'small'
      ? { fontSize: 12 }
      : { paddingTop: 8, paddingBottom: 8, fontSize: 20 };
  if (isLoading) {
    return (
      <div>
        <LoadingIndicator />
      </div>
    );
  }
  return (
    <div>
      <Button
        type="submit"
        // style={styling}
        id={`checkout-button-${productId}`}
        // onClick={stripeStandardCheckout}
        onClick={handleClick}
        color="secondary"
        size="small"
        fullWidth
        // variant={isSelected ? "outlined" : "contained"}
        variant="contained"
        style={{ width: 200 }}
      >
        {isSelected ? 'Selected' : 'Renew'}
        <br />
        {course.name}
      </Button>
      <div style={{ textAlign: 'center', margin: 12 }}>
        <p>
          $99/year
        </p>
      </div>
    </div>
  );
};
RenewButton.propTypes = {
  course: PropTypes.object,
  handleClassClick: PropTypes.func,
  index: PropTypes.number,
  showDiscount: PropTypes.bool,
  isRenewal: PropTypes.bool,
  size: PropTypes.string
}
export default RenewButton;